import { get } from 'miniruche/services/api';

export function fetchUser() {
    return get('miniruche/users/me');
}
